import { notify, type NotifySeverity } from "frontend/src/feedback/SnackbarProvider";

interface NotificationOptions {
  message: string;
  title?: string;
  type?: NotifySeverity;
  description?: string;
  duration?: number | null;
  key?: string;
}

// Redux-style helper wrapping the shared snackbar. antd's title/message became
// notify's message/description (title is the bold line when a description exists).
export const addFlashNotification = (notificationOptions: NotificationOptions) => {
  const { title, type = "info", message: description, duration, key } = notificationOptions;
  notify({
    severity: type,
    message: title ?? description,
    description: title ? description : undefined,
    duration,
    key,
  });
  return { type: "DO_NOTHING" };
};
